import { Button, Modal } from "@material-ui/core";
import React, { FC, useEffect, useState } from "react";
import styles from "./PrintStatusModal.module.scss";
import printerGif from "./printer.gif";

const CLOSE_BUTTON_DELAY_MS = 5000;

export interface IPrintStatusModalProps {
  open: boolean;
  onClose: () => void;
  remainingPrints: number;
}

const PrintStatusModal: FC<IPrintStatusModalProps> = ({
  open,
  onClose,
  remainingPrints,
}) => {
  const [showCloseButton, setShowCloseButton] = useState(false);

  useEffect(() => {
    if (!open) {
      setShowCloseButton(false);
      return;
    }
    const timer = setTimeout(() => {
      setShowCloseButton(true);
    }, CLOSE_BUTTON_DELAY_MS);
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={styles.modalOverlay}
      BackdropProps={{ className: styles.backdrop }}
    >
      <div className={styles.modalContent}>
        <div className={styles.centerContent}>
          <img
            src={printerGif}
            alt="Impressão"
            className={styles.printerGif}
          />
          <p className={styles.message}>
            Aguarde a impressão. Restam {remainingPrints}{" "}
            {remainingPrints === 1 ? "impressão" : "impressões"}.
          </p>
          {showCloseButton && (
            <Button
              className={styles.closeButton}
              onClick={onClose}
              variant="contained"
              color="primary"
            >
              Fechar
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default PrintStatusModal;
